export const PRE_ENROLMENT_HARD_LIMIT_FIELD = 'dayforce_clock_facial_pre_enrolment_hard_limit_minutes';
export const PRE_ENROLMENT_HARD_LIMIT_MINIMUM_MINUTES = 120;
export const PRE_ENROLMENT_HARD_LIMIT_STEP_MINUTES = 30;
export const PRE_ENROLMENT_INACTIVITY_FIELD = 'dayforce_clock_facial_pre_enrolment_inactivity_days';
export const PRE_ENROLMENT_INACTIVITY_MINIMUM_DAYS = 1;
export const PRE_ENROLMENT_INACTIVITY_MAXIMUM_DAYS = 90;
